import { Grid, Paper, Tabs, Tab, TabPanel } from "../../../../components";
import {
  TabConjuntoTransporte,
  TabItinerarioTransporte,
  TabDocumentosFiscaisEletronicos,
  TabDadosContratacao,
  TabControleRodoviario,
} from "./";
const ITINERARIO_TRANSPORTE = 0;
const DOCUMENTOS_FISCAIS_ELETRONICOS = 1;
const CONJUNTO_TRANSPORTE = 2;
const CONTROLE_RODOVIARIO = 3;
const DADOS_CONTRATACAO = 4;

export default function TabsMdfe(props) {
  const handleAbaChange = (e, value) => {
    props.setAbaValue(value);
  };

  const tabProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper>
          <Tabs
            value={props.abaValue}
            onChange={handleAbaChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            scrollButtons="auto"
          >
            <Tab
              label="Itinerário de Transporte"
              {...tabProps(ITINERARIO_TRANSPORTE)}
            />
            <Tab
              label="Documentos fiscais eletrônicos"
              {...tabProps(DOCUMENTOS_FISCAIS_ELETRONICOS)}
            />
            <Tab
              label="Conjunto de Transporte"
              {...tabProps(CONJUNTO_TRANSPORTE)}
            />
            <Tab
              label="Controle Rodoviário"
              {...tabProps(CONTROLE_RODOVIARIO)}
            />
            <Tab
              label="Dados da Contratação"
              {...tabProps(DADOS_CONTRATACAO)}
            />
          </Tabs>
        </Paper>
        <TabPanel value={props.abaValue} index={ITINERARIO_TRANSPORTE}>
          <TabItinerarioTransporte
            carregamentos={props.carregamentos}
            setCarregamentos={props.setCarregamentos}
            estados={props.estados}
            id={props.id}
            setLoading={props.setLoading}
            status={props.status}
            percursos={props.percursos}
            setPercursos={props.setPercursos}
          />
        </TabPanel>
        <TabPanel value={props.abaValue} index={DOCUMENTOS_FISCAIS_ELETRONICOS}>
          <TabDocumentosFiscaisEletronicos
            estados={props.estados}
            nfsSaida={props.nfsSaida}
            setNfsSaida={props.setNfsSaida}
            id={props.id}
            setLoading={props.setLoading}
            montarNfsSaidas={props.montarNfsSaidas}
            status={props.status}
            calcularTotaisNfsSaida={props.calcularTotaisNfsSaida}
            calcularValorTotalNfSaida={props.calcularValorTotalNfSaida}
          />
        </TabPanel>
        <TabPanel value={props.abaValue} index={CONJUNTO_TRANSPORTE}>
          <TabConjuntoTransporte
            setCondutoresMdfe={props.setCondutoresMdfe}
            condutoresMdfe={props.condutoresMdfe}
            id={props.id}
            setLoading={props.setLoading}
            status={props.status}
            reboques={props.reboques}
            setReboques={props.setReboques}
          />
        </TabPanel>
        <TabPanel value={props.abaValue} index={CONTROLE_RODOVIARIO}>
          <TabControleRodoviario
            id={props.id}
            setLoading={props.setLoading}
            status={props.status}
            nfsSaida={props.nfsSaida}
            lacres={props.lacres}
            setLacres={props.setLacres}
            pedagios={props.pedagios}
            setPedagios={props.setPedagios}
          />
        </TabPanel>
        <TabPanel value={props.abaValue} index={DADOS_CONTRATACAO}>
          <TabDadosContratacao
            id={props.id}
            setLoading={props.setLoading}
            status={props.status}
            contratantes={props.contratantes}
            setContratantes={props.setContratantes}
            ciots={props.ciots}
            setCiots={props.setCiots}
          />
        </TabPanel>
      </Grid>
    </Grid>
  );
}
